"use client";

import Link from "next/link";
import { useSession } from "next-auth/react";
import { UserMenu } from "@/components/auth/UserMenu";
import { LanguageSwitcher } from "@/components/layout/LanguageSwitcher";

interface HeaderProps {
  onMenuClick?: () => void;
}

export function Header({ onMenuClick }: HeaderProps) {
  const { data: session } = useSession();

  return (
    <header className="sticky top-0 z-40 border-b border-white/8 bg-black/90 backdrop-blur-xl">
      <div className="flex h-14 items-center justify-between px-4 lg:px-6">
        <div className="flex items-center gap-3">
          {/* Hamburger menu */}
          <button
            onClick={onMenuClick}
            className="rounded-xl p-2 text-text-muted hover:bg-white/5 hover:text-white transition-colors touch-target"
          >
            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
            </svg>
          </button>

          <Link href="/dashboard" className="flex items-center gap-2">
            <div className="flex h-8 w-8 items-center justify-center rounded-xl bg-gradient-to-br from-amber-200 via-amber-100 to-amber-300 shadow-sm">
              <svg className="h-4 w-4 text-amber-900" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2L3 9l9 13 9-13-9-7zm0 3.5L17 9l-5 7.5L7 9l5-3.5z"/>
              </svg>
            </div>
            <span className="hidden text-lg font-semibold text-white sm:block tracking-tight">Facet</span>
            <span className="hidden text-[10px] font-medium text-amber-200/60 uppercase tracking-widest sm:block">AI</span>
          </Link>
        </div>

        <div className="flex items-center gap-3">
          <LanguageSwitcher compact />
          {session?.user && <UserMenu user={session.user} />}
        </div>
      </div>
    </header>
  );
}
